'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { gsap } from 'gsap';
import type { Work } from '@/data/works';
const WorkCard = t0 => {
  const $ = _c(16);
  const {
    work
  } = t0;
  const cardRef = useRef(null);
  const hoverTween = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!hoverTween.current && cardRef.current) {
        hoverTween.current = gsap.to(cardRef.current, {
          y: 6,
          skewX: 0.25,
          scale: 0.97,
          duration: 0.25,
          ease: "back.inOut"
        });
      } else {
        hoverTween.current?.play();
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      hoverTween.current?.reverse();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleMouseLeave = t2;
  let t3;
  if ($[2] !== work.name) {
    t3 = <h5>{work.name}</h5>;
    $[2] = work.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== work.date) {
    t4 = <time>{work.date}</time>;
    $[4] = work.date;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="font-primary flex justify-between text-sm font-medium text-neutral-300 uppercase">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== work.outcomes) {
    t6 = work.outcomes?.map(_temp);
    $[9] = work.outcomes;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="grid aspect-square place-content-center bg-neutral-600"><ul className="marker:text-accent flex flex-col text-lg font-normal text-neutral-300">{t6}</ul></div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <div ref={cardRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="will-change-transform">{t5}{t7}</div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default WorkCard;
function _temp(item) {
  return <li key={item} className="list-disc"><span>{item}</span></li>;
}